import Avatar from '@jimmyboys/liita-ui/dist/components/Avatar'
import Icon from '@jimmyboys/liita-ui/dist/components/Icon'
import styles from './MedicalOpinionCard.module.sass'

const { memo } = require('react')

const MedicalOpinionCard = memo((props) => {
	const { className, data, ...attributes } = props
	const labels = data.$cardLabels || {}

	return (
		<div
			{...attributes}
			className={`card ${styles['root'] || ''} ${className || ''} ${
				styles[`${data?.$layout}-layout`] || ''
			}`}
		>
			<span className={styles['status-circle']} />
			<div className={styles['header-content']}>
				<span>
					<h5>
						<Icon
							className={styles['text-icon']}
							name='calendar'
							width='14px'
							height='14px'
						/>
						{data?.responseDate?.shortDateFormat ||
							data?.creationDate?.shortDateFormat}
					</h5>
					<small>{labels?.medicalOpinion}</small>
				</span>
				<div className={`${styles['status-container']}`}>
					<div>
						<h5>
							{data?.responseUser?.name ||
								data?.creationUser?.name}
						</h5>
						<small>{data?.medicalObservationType}</small>
					</div>
					<span className={styles['avatar-container']}>
						<Avatar
							rounded
							className={styles['avatar']}
							user={data?.responseUser || data?.creationUser}
						/>
					</span>
				</div>
			</div>
			{data.$detailLevel !== 'summary' && (
				<>
					{' '}
					<div className={styles['card-table']}>
						{data.responseUser && (
							<div
								className={`${styles['answer-container']} ${styles['dynamic-text']}`}
							>
								{data?.answers.map((item, index) => (
									<div key={index}>
										<h5>{item.question}</h5>
										<p>{item.answer}</p>
									</div>
								))}
							</div>
						)}
					</div>
					<div
						className={`${styles['dynamic-text']} ${styles['request-author']}`}
					>
						<h5>{data?.requestedByDate}</h5>
						<p>{data?.submittedMedicalRequest}</p>
					</div>
				</>
			)}
		</div>
	)
})

MedicalOpinionCard.displayName = 'MedicalOpinionCard'
MedicalOpinionCard.defaultHeight = 107
MedicalOpinionCard.extraHeight = 13
MedicalOpinionCard.summaryDefaultHeight = 50

export default MedicalOpinionCard
